import React from "react";
import { Mail, Twitter, Github, Linkedin, Instagram } from "lucide-react";

const ContactPage = () => {
  const contactLinks = [
    {
      icon: Mail,
      label: "Email",
      handle: "prajharshit@gmail.com",
      url: "mailto:prajharshit@gmail.com",
    },
    {
      icon: Twitter,
      label: "Twitter / X",
      handle: "@harshitpraj",
      url: "https://x.com/harshitpraj",
    },
    {
      icon: Github,
      label: "GitHub",
      handle: "ha1rshit",
      url: "https://github.com/ha1rshit",
    },
    {
      icon: Linkedin,
      label: "LinkedIn",
      handle: "harshitpraj",
      url: "https://www.linkedin.com/in/harshitpraj",
    },
    {
      icon: Instagram,
      label: "Instagram",
      handle: "@harshitpraj",
      url: "https://instagram.com/harshitpraj",
    },
  ];

  return (
    <div className="w-full bg-[#0f0f0f] text-[#f2f2f2] min-h-screen">
      <div className="max-w-[800px] mx-auto px-5 py-[80px] md:py-[120px]">
        {/* Header */}
        <div className="mb-2">
          <span className="text-[11px] uppercase tracking-[0.12em] text-[#555555] border border-[#222222] px-3 py-1 rounded inline-block font-mono">
            CONTACT
          </span>
        </div>
        <h1
          className="text-[36px] sm:text-[48px] font-bold text-[#f2f2f2] mb-3"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          Let's build something.
        </h1>
        <p className="text-[15px] text-[#666666] mb-[60px]">
          Not looking for a job. Open to collabs, ideas, and building together.
        </p>

        {/* Social Rows */}
        <div className="divide-y divide-[#1a1a1a] border-t border-b border-[#1a1a1a] mb-[40px]">
          {contactLinks.map((item) => {
            const Icon = item.icon;
            return (
              <a
                key={item.label}
                href={item.url}
                target={item.url.startsWith("mailto:") ? "_self" : "_blank"}
                rel={item.url.startsWith("mailto:") ? "" : "noopener noreferrer"}
                className="py-5 px-3 flex items-center justify-between hover:bg-[#161616] transition-colors rounded group"
              >
                <div className="flex items-center space-x-4">
                  <Icon className="w-5 h-5 text-[#666666] group-hover:text-white transition-colors" />
                  <span
                    className="text-[16px] font-medium text-[#f2f2f2] group-hover:text-white transition-colors"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}
                  >
                    {item.label}
                  </span>
                </div>
                <span className="text-sm text-[#666666] font-mono group-hover:text-[#999999] transition-colors">
                  {item.handle} →
                </span>
              </a>
            );
          })}
        </div>

        {/* Note */}
        <p className="text-[13px] text-[#555555] font-mono">
          I usually respond within 24–48 hours. Best for collabs: Twitter DM or Email.
        </p>
      </div>
    </div>
  );
};

export default ContactPage;
